/*
 * テナント
 */
 import Vue from 'vue'
 import * as httpConst from '../../../constants/httpConst'

 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/tenants`

 const tenant = {
  namespaced: true,
  actions: {
    index () {
      const api_path = `${API_PATH}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
  },
}

export default tenant

